// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/product-offering-exchange/product-offering-exchange.component.scss
// module id = 330
// module chunks = 0